import { BaseEntity } from "yt-ng-framework";

export class Tarifa extends BaseEntity{
    constructor(){
        super();
    }

    Sifra:string = null;
    Naziv:string = null;
    AktuelnaStopa: number = null;
    UnCode: string = null;
    DrzavaID: number = null;
    EName:string = null;
    ETaxTypeCode:string = null;
    SiriOpis: string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Sifra=input.Sifra;
        this.Naziv=input.Naziv;
        this.AktuelnaStopa=input.AktuelnaStopa;
        this.UnCode = input.UnCode;
        this.DrzavaID = input.DrzavaID;
        this.EName = input.EName;
        this.ETaxTypeCode = input.ETaxTypeCode;
        this.SiriOpis = input.Naziv + " " +input.AktuelnaStopa + "%";
        return this;
    }
    Serialize(input:Tarifa){
        return input;
    }
}